import React from "react";
import { Box, Button, Grid, LinearProgress } from "@material-ui/core";
import TextFieldHelper from "../../UI/FormHelper/TextFieldHelper";
import UserAutoComplete from "../../Form/UserAutoComplete";
import { Alert } from "@material-ui/lab";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import ChipInput from "material-ui-chip-input";
import FieldDatePicker from "../../Form/FieldDatePicker";

const PersonAddFormFields = (props) => {
  const {
    values,
    touched,
    handleChange,
    isValid,
    setFieldTouched,
    setFieldValue,
    handleClose,
    handleSubmit,
    errors,
  } = props;

  const change = (name, e) => {
    handleChange(e);
    setFieldTouched(name, true, false);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper title={"نام"} fieldName={"name"} {...props} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"نام خانوادگی"}
                fieldName={"lastname"}
                {...props}
              />
            </Box>
          </Grid>

          {props.isModal ? null : (
            <Wrapper>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <UserAutoComplete
                    title={"معرف"}
                    fieldName={"recommender_id"}
                    fieldNameShow={"recommender_fullname"}
                    setFieldValue={setFieldValue}
                    value={values.recommender_fullname}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <UserAutoComplete
                    title={"ضامن"}
                    fieldName={"guarantor_id"}
                    fieldNameShow={"guarantor_fullname"}
                    setFieldValue={setFieldValue}
                    value={values.guarantor_fullname}
                  />
                </Box>
              </Grid>
            </Wrapper>
          )}

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره شناسنامه"}
                fieldName={"id_number"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره ملی"}
                fieldName={"id_card_number"}
                {...props}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <ChipInput
                value={values["phone"]}
                onChange={(e) => {
                  setFieldValue("phone", e);
                }}
                onDelete={(chip, index) => {
                  setFieldValue(
                    "phone",
                    values["phone"].filter((ch) => ch != chip),
                  );
                }}
                onAdd={(chip) => {
                  setFieldValue("phone", [...values["phone"], chip]);
                }}
                fullWidth={true}
                variant={"outlined"}
                label={"تلفن"}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <ChipInput
                value={values["mobile"]}
                onChange={(e) => {
                  setFieldValue("mobile", e);
                }}
                onDelete={(chip, index) => {
                  setFieldValue(
                    "mobile",
                    values["mobile"].filter((ch) => ch != chip),
                  );
                }}
                onAdd={(chip) => {
                  setFieldValue("mobile", [...values["mobile"], chip]);
                }}
                fullWidth={true}
                variant={"outlined"}
                label={"موبایل"}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper title={"ایمیل"} fieldName={"email"} {...props} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"سقف اعتبار"}
                fieldName={"credit"}
                {...props}
                isNumber={true}
              />
            </Box>
          </Grid>

          {/*<Grid item xs={12} md={6}>*/}
          {/*    <Box p={1}>*/}
          {/*        <PersonAddFormGroup*/}
          {/*            {...props}*/}
          {/*        />*/}
          {/*    </Box>*/}
          {/*</Grid>*/}
          {props.isModal || !props.isAdmin ? null : (
            <Wrapper>
              <Grid item xs={12} md={12}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"نام کاربری"}
                    fieldName={"username"}
                    {...props}
                  />
                </Box>
              </Grid>
              {props.isEdit ? (
                <Grid item xs={12}>
                  <Alert severity="info">
                    در صورتی که قصد تغییر کلمه عبور را دارید وارد نمایید
                  </Alert>
                </Grid>
              ) : null}
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"کلمه عبور"}
                    fieldName={"password"}
                    type={"password"}
                    {...props}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"کلمه عبور تکراری"}
                    fieldName={"password_repeat"}
                    type={"password"}
                    {...props}
                  />
                </Box>
              </Grid>
            </Wrapper>
          )}

          <Grid item xs={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"نام پدر"}
                fieldName={"father"}
                {...props}
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box p={1}>
              <TextFieldHelper title={"شغل"} fieldName={"job"} {...props} />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"کدپستی"}
                fieldName={"postal_code"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"محل صدور شناسنامه"}
                fieldName={"place_of_issuance"}
                multiline={true}
                {...props}
              />
            </Box>
          </Grid>
          <Grid item xs={6} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ تولد"}
                fieldName={"birthday"}
                {...props}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"آدرس"}
                fieldName={"address"}
                multiline={true}
                {...props}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"توضیحات"}
                fieldName={"description"}
                {...props}
              />
            </Box>
          </Grid>

          {props.isEdit ? (
            <Wrapper>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ویرایش"}
                    fieldName={"updated_at"}
                    {...props}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ثبت"}
                    fieldName={"created_at"}
                    disabled={true}
                    {...props}
                  />
                </Box>
              </Grid>
            </Wrapper>
          ) : null}
        </Grid>

        <Box mt={2}>
          {props.loading ? (
            <LinearProgress />
          ) : (
            <Wrapper>
              <Button
                type="submit"
                size={"large"}
                color={"primary"}
                fullWidth={true}
                variant={"contained"}
              >
                {props.isEdit ? "ویرایش کاربر" : "ثبت کاربر"}
              </Button>
            </Wrapper>
          )}
        </Box>
      </form>
    </div>
  );
};

export default PersonAddFormFields;
